
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 24h-5.38a.5.5 0 01-.5-.5V12a.5.5 0 01.5-.5h5.38a.5.5 0 01.5.5v11.5a.5.5 0 01-.5.5zm-4.88-1H23V12.5h-4.38zM5.88 24H.5a.5.5 0 01-.5-.5V.5A.5.5 0 01.5 0h5.38a.5.5 0 01.5.5v23a.5.5 0 01-.5.5zM1 23h4.38V1H1zm13.81 1H9.43a.5.5 0 01-.5-.5V6.75a.5.5 0 01.5-.5h5.38a.5.5 0 01.5.5V23.5a.5.5 0 01-.5.5zm-4.88-1h4.38V7.25H9.93z"}})])
          )
        }
      }
    